<!-- Navbar Toggler -->
<div class="d-flex align-items-center"
	[ngClass]="{'justify-content-between' : loggedinUser.isAdmin}">
	<button pmd-btn
		pmdRipple
		pmd-btn-fab
		pmd-btn-flat
		size="xs"
		(click)="showSideBar()"
		class="pmd-sidebar-toggle d-xl-none pmd-btn-rounded ms-2"
		aria-label="Press enter to open the left sidebar navigation">
		<i class="material-symbols-outlined md-dark">menu</i>
	</button>
	<!-- Navbar brand -->

	<!-- Condition will be changed once APIs changes are up on dev (Multiple Outlet) -->
	<div class="align-items-center d-none d-lg-flex me-4">
		<nav aria-label="breadcrumb mb-0"
			class="breadcrumb mb-0"
			*ngIf="dashboardText">
			<ol class="breadcrumb pmd-breadcrumb">
				<li [class]="'breadcrumb-item'"
					aria-current="page">
					<a [routerLink]="['/dashboard']"
						[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/dashboard')}"
						class="text-decoration-none">
						Dashboard
					</a>
				</li>
			</ol>
		</nav>
		<app-breadcrumb></app-breadcrumb>
	</div>
</div>
<pmd-navbar-right-icon class="d-flex align-items-center pf-navbar-right-icon gap-3">
	<form class="form-inline w-100"
		autocomplete="off"
		*ngIf="loggedinUser.isAdmin && !['/push-to-petpooja', '/tally-config', '/push-to-retail-pos', '/push-to-tally', '/push-to-petpooja/manage-poss-tags', '/push-to-retail-pos/manage-invoice-tags'].includes(router.url)"
		class="d-none d-lg-block flex-1">
		<div class="d-flex align-items-center gap-3"
			*ngIf="parentCompanyList.length">
			<div class="d-flex gap-2 align-items-center mb-3 mb-lg-0 px-lg-0 me-3">
				<label for="company-name"
					class="col-form-label pb-0">Company</label>
				<ng-select [searchable]="true"
					[clearable]="false"
					labelForId="company-name"
					[markFirst]="true"
					[items]="parentCompanyList"
					[formControl]="selectedCompany"
					bindLabel="name"
					bindValue="id"
					appearance="outline"
					class="pmd-select pmd-select-outline khr-header-entity-dropdown "
					placeholder="Company"
					name="companyNameFilter"
					ng-click="active!= ng-select-opened">
				</ng-select>
			</div>
			<div class="d-flex gap-2 align-items-center"
				*ngIf="loggedinUser.isAdmin && !['/push-to-petpooja', '/tally-config', '/push-to-retail-pos', '/push-to-tally'].includes(router.url)">
				<label for="select-entity"
					class="col-form-label pb-0">Entity:</label>
				<ng-select groupBy="group"
					id="select-entity"
					name="select-entity"
					[items]="entities"
					[formControl]="selectedEntities"
					appearance="outline"
					[multiple]="true"
					pmdTextField
					placeholder="Select Entity"
					[clearable]="false"
					[clearSearchOnAdd]="true"
					bindLabel="name"
					class="pmd-select pmd-select-outline khr-header-entity-dropdown"
					(close)="onEntitySelectionClose()"
					(change)="onEntityChange()"
					(open)="onSelectionOpen()"
					[closeOnSelect]="false">
					<ng-template ng-option-tmp
						let-item="item">
						<div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
							{{item.name}}</div>
					</ng-template>
					<ng-template ng-option-tmp
						let-item="item">
						<div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
							{{item.name}}</div>
					</ng-template>

					<ng-template ng-multi-label-tmp
						let-items="items"
						let-clear="clear">
						<div class="ng-value"
							*ngFor="let item of items | slice:0:1">
							<span class="ng-value-label">{{item.name}}</span>
						</div>
						<div class="ng-value ts-more"
							*ngIf="items.length >1 && items.length != entities.length">
							<span class="ng-value-label">+{{items.length - 1}} more...</span>
						</div>
					</ng-template>

				</ng-select>
			</div>
		</div>
	</form>
	<div class="khr-entity-dd navbar-multi-select-entity d-flex align-items-center gap-2"
		*ngIf="loggedinUser.isOwner && !['/tally-config', '/push-to-tally', '/push-to-petpooja', '/push-to-retail-pos', '/push-to-petpooja/manage-poss-tags', '/push-to-retail-pos/manage-invoice-tags'].includes(router.url)">
		<label for="entities"
			class="d-none d-lg-block">Entity</label>
		<pmd-input-group-outline>
			<ng-select groupBy="group"
				id="select-entity"
				name="select-entity"
				[formControl]="selectedEntities"
				appearance="outline"
				[items]="entities"
				[multiple]="true"
				pmdTextField
				placeholder="Select Entity"
				[clearable]="false"
				[clearSearchOnAdd]="true"
				bindLabel="name"
				class="pmd-select pmd-select-outline"
				(close)="onEntitySelectionClose()"
				(change)="onEntityChange()"
				(open)="onSelectionOpen()"
				[closeOnSelect]="false">
				<ng-template ng-option-tmp
					let-item="item">
					<div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
						{{item.name}}</div>
				</ng-template>
				<ng-template ng-option-tmp
					let-item="item">
					<div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
						{{item.name}}</div>
				</ng-template>

				<ng-template ng-multi-label-tmp
					let-items="items"
					let-clear="clear">
					<div class="ng-value"
						*ngFor="let item of items | slice:0:1">
						<span class="ng-value-label">{{item.name}}</span>
					</div>
					<div class="ng-value ts-more"
						*ngIf="items.length >1 && items.length != entities.length">
						<span class="ng-value-label">+{{items.length - 1}} more...</span>
					</div>
				</ng-template>

			</ng-select>
		</pmd-input-group-outline>
	</div>
	<ng-container *ngIf="PEFormGroup && ['/push-to-petpooja'].includes(router.url)">
		<form [formGroup]="">
			<div class="switch-toggle toggle_secondary switch-expenditure"
				container="body"
				placement="bottom">
				<div class="toggle-button-cover">
					<div class="button-cover">
						<div class="button b2">
							<input type="checkbox"
								id="pe-checkbox"
								[formControl]="invoiceFieldType"
								(change)="setFieldType();"
								tabindex="0"
								[checked]="peF.invoiceFieldType.value?.toLowerCase() == appGlobals.EXPENSE.toLowerCase() ? true : false"
								class="checkbox" />
							<div class="knobs">
								<span>Purchase</span>
							</div>
							<div class="layer"></div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</ng-container>
	<div class="divider-vertical d-none d-lg-block"></div>
	<div *ngIf="(loggedinUser.isOwner || loggedinUser.isOutlet) && !router.url.includes('upload')"
		class="search-upload position-relative top-0 end-0">
		<button type="button"
			pmd-btn-raised
			[disabled]="!authService.secondaryOwnerCanAccess('/invoice/upload')"
			[routerLink]="['/invoice/upload']"
			pmd-btn
			color="secondary"
			class="btn btn-upload-sm me-0">
			<svg _ngcontent-nra-c115=""
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="23.401"
				viewBox="0 0 26.934 23.401"
				class="upload-icon">
				<g _ngcontent-nra-c115=""
					id="upload"
					transform="translate(0 -0.999)">
					<path _ngcontent-nra-c115=""
						id="Path_306"
						data-name="Path 306"
						d="M.842,9.9a.842.842,0,0,1,.842.842V14.95a1.683,1.683,0,0,0,1.683,1.683h20.2a1.683,1.683,0,0,0,1.683-1.683V10.742a.842.842,0,1,1,1.683,0V14.95a3.367,3.367,0,0,1-3.367,3.367H3.367A3.367,3.367,0,0,1,0,14.95V10.742A.842.842,0,0,1,.842,9.9Z"
						transform="translate(0 6.083)"
						fill="#2980b9"></path>
					<path _ngcontent-nra-c115=""
						id="Path_307"
						data-name="Path 307"
						d="M9.8,1.246a.842.842,0,0,1,1.192,0l5.05,5.05a.843.843,0,1,1-1.192,1.192L11.234,3.874v14.8a.842.842,0,0,1-1.683,0V3.874L5.938,7.488A.843.843,0,0,1,4.746,6.3L9.8,1.246Z"
						transform="translate(3.075 0)"
						fill="#ffffff"></path>
				</g>
			</svg>
			<span class="d-none d-xl-block">Upload Invoice</span>
		</button>
	</div>
	<div class="divider-vertical d-none d-lg-block"
		*ngIf="!loggedinUser.isAdmin && !router.url.includes('upload')"></div>
	<div class="dropdown pmd-dropdown pmd-user-info p-0 "
		pmdDropdown>
		<a href="javascript:void(0);"
			class="btn-user dropdown-toggle d-flex align-items-center ps-0"
			pmdDropdownToggle
			(click)="toggleDropdown()">
			<span class="pmd-avatar bg-secondary text-white fs-14 me-0 me-sm-2">
				<div class="image-profile-page d-flex align-items-center gap-2"
					*ngIf="loggedInUserThumbnail else elseTemplate">
					<img [src]="loggedInUserThumbnail || 'assets/images/placeholder-image.png'"
						class="profile-img w-100 h-100 object-fit-cover"
						alt="placeholder-image.png" />
				</div>
				<ng-template #elseTemplate>
					{{loggedinUser.shortName?.slice(0, 3)}}
				</ng-template>
			</span>
			<div class="flex-grow-1 d-none d-xl-block khr-logedin-user">
				<p class="mb-0 text-black fw-semibold text-truncate"
					title='{{ loggedInUserName ?? loggedinUser.name }}'>
					{{ loggedInUserName ?? loggedinUser.name }}
				</p>
				<p class="mb-0 fs-12 text-truncate"
					title='{{ companyName ?? loggedinUser.company.name }}'>
					{{ companyName ?? loggedinUser.company.name }}
				</p>
			</div>
			<i class="ms-2 material-symbols-outlined pmd-icon-sm d-none d-md-block">expand_more</i>
		</a>

		<ul class="dropdown-menu dropdown-menu-right"
			*pmdDropdownMenu
			aria-labelledby="userNavbarDropdown"
			role="menu">
			<li>
				<a class="dropdown-item d-flex align-items-center"
					routerLinkActive='active'
					[routerLink]="loggedinUser.isOwner ? loggedinUser.isDemo ? ['/entity'] : ['/profile'] : loggedinUser.isOutlet ? ['/profile'] : null"
					pmdRipple
					aria-label="Press enter to view profile"
					role="menuitem"
					tabindex="0">
					<svg width="24"
						class="me-2"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M19.25 21C19.25 19.731 19.2442 19.1444 19.1543 18.7266L19.1104 18.5566C18.815 17.583 18.0819 16.8079 17.1358 16.4551L16.9434 16.3896C16.5089 16.2579 15.95 16.25 14.5 16.25H9.50005C8.231 16.25 7.64449 16.2558 7.22661 16.3457L7.05669 16.3896C6.08302 16.685 5.30791 17.4181 4.95513 18.3643L4.8897 18.5566C4.75794 18.9911 4.75005 19.55 4.75005 21C4.75005 21.4142 4.41426 21.75 4.00005 21.75C3.58583 21.75 3.25005 21.4142 3.25005 21C3.25005 19.659 3.2415 18.8222 3.45415 18.1211L3.54888 17.8408C4.06432 16.4575 5.19776 15.3859 6.62114 14.9541L6.89165 14.8848C7.53974 14.7439 8.32693 14.75 9.50005 14.75H14.5C15.841 14.75 16.6779 14.7414 17.379 14.9541L17.6592 15.0488C19.0425 15.5643 20.1142 16.6977 20.5459 18.1211L20.6153 18.3916C20.7561 19.0397 20.75 19.8269 20.75 21C20.75 21.4142 20.4143 21.75 20 21.75C19.5858 21.75 19.25 21.4142 19.25 21ZM15.75 7.5C15.75 5.42893 14.0711 3.75 12 3.75C9.92898 3.75 8.25005 5.42893 8.25005 7.5C8.25005 9.57107 9.92898 11.25 12 11.25C14.0711 11.25 15.75 9.57107 15.75 7.5ZM17.25 7.5C17.25 10.3995 14.8995 12.75 12 12.75C9.10055 12.75 6.75005 10.3995 6.75005 7.5C6.75005 4.6005 9.10055 2.25 12 2.25C14.8995 2.25 17.25 4.6005 17.25 7.5Z"
							fill="black" />
					</svg>

					Profile
				</a>
			</li>
			<li>
				<div class="dropdown-item d-flex align-items-center justify-content-between"
					pmdRipple
					aria-label="Press enter to logout from the tool"
					*ngIf="loggedinUser.isOwner || loggedinUser.isOutlet"
					role="menuitem"
					tabindex="0">
					<span class="d-flex align-items-center pf-cursor-pointer"
						pmdTooltip="Sync code"
						container="body"
						placement="bottom">
						<svg width="24"
							height="24"
							class="me-2"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M18.2051 20.5322C18.2051 21.287 17.5927 21.8984 16.8379 21.8984H6.66699C5.91233 21.8984 5.30078 21.287 5.30078 20.5322V19.6006H18.2051V20.5322ZM19.5049 18.9502C19.5047 18.5914 19.2133 18.3008 18.8545 18.3008H4.65039C4.29154 18.3008 4.00021 18.5914 4 18.9502V20.5322C4 22.0049 5.19433 23.1992 6.66699 23.1992H16.8379C18.3107 23.1992 19.5049 22.005 19.5049 20.5322V18.9502Z"
								fill="#212121" />
							<path
								d="M18.8545 19.6016L18.9854 19.5879C19.2817 19.5274 19.5049 19.2654 19.5049 18.9512V3.86426C19.5048 3.50537 19.2134 3.21484 18.8545 3.21484H4.65039C4.29148 3.21484 4.00012 3.50537 4 3.86426V18.9512L4.01367 19.082C4.07424 19.3783 4.33624 19.6016 4.65039 19.6016H18.8545ZM5.30078 4.51465H18.2051V18.3008H5.30078V4.51465Z"
								fill="#212121" />
							<path
								d="M18.2051 3.21484H5.30078V2.66504L5.30762 2.52539C5.37775 1.83644 5.95952 1.29883 6.66699 1.29883H16.8379C17.5925 1.29883 18.2049 1.91047 18.2051 2.66504V3.21484ZM19.5049 2.66504C19.5047 1.1925 18.3105 -0.000976562 16.8379 -0.000976562H6.66699C5.28637 -0.000976562 4.1503 1.04801 4.01367 2.39258L4 2.66504V3.86523L4.01367 3.99609C4.07424 4.29235 4.33624 4.51562 4.65039 4.51562H18.8545L18.9854 4.50195C19.2817 4.44149 19.5049 4.17948 19.5049 3.86523V2.66504Z"
								fill="#212121" />
							<path
								d="M10.8453 13.8013C11.1388 13.9126 11.4628 13.7977 11.6246 13.5425L11.6832 13.4243L13.0357 9.85792L13.0699 9.73097C13.1182 9.43261 12.9523 9.13149 12.6587 9.02003C12.365 8.90864 12.0411 9.02425 11.8794 9.2798L11.8199 9.39698L10.4683 12.9634L10.4341 13.0903C10.3857 13.3888 10.5516 13.6898 10.8453 13.8013Z"
								fill="#212121" />
							<path
								d="M15.1363 9.34887C14.9509 9.04154 14.5511 8.94285 14.2437 9.12817C13.9366 9.31353 13.838 9.71249 14.023 10.0198L15.1363 9.34887ZM14.2534 13.6936C14.5252 13.851 14.8641 13.7896 15.065 13.5637L15.1421 13.4573L16.1607 11.6995C16.2793 11.4946 16.2768 11.2412 16.1548 11.0383L15.1363 9.34887L14.5796 9.68481L14.023 10.0198L14.8423 11.3811L14.0171 12.8049L13.9634 12.925C13.8672 13.2117 13.9817 13.536 14.2534 13.6936Z"
								fill="#212121" />
							<path
								d="M8.44093 13.5638C8.64183 13.7895 8.97981 13.851 9.25148 13.6937C9.56211 13.5138 9.66872 13.1157 9.48878 12.8051L8.66261 11.3812L9.48292 10.0199C9.66784 9.71254 9.56851 9.31354 9.26124 9.1283C8.95393 8.94309 8.55506 9.04185 8.36964 9.34901L7.35109 11.0385C7.22895 11.2413 7.22652 11.4947 7.34523 11.6996L8.36378 13.4574L8.44093 13.5638Z"
								fill="#212121" />
						</svg>


						<span>
							{{ syncCode }}
						</span>
					</span>
					<div class="d-flex align-items-center text-center position-relative">
						<button class="me-1 my-0 sync-buttons"
							type="button"
							pmdBtn
							pmd-btn-outline
							color="dark"
							pmdRipple
							size="xs"
							pmdTooltip="Copy sync code"
							container="body"
							placement="bottom"
							(click)="copySyncCodeToClipboard()">
							<svg width="15"
								height="20"
								viewBox="0 0 15 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M11.7062 2.20984C11.7061 1.82383 11.3924 1.51107 11.0064 1.51107H4.75005L1.50911 4.752V15.1146C1.50911 15.5006 1.82188 15.8133 2.20789 15.8133H11.0064C11.3924 15.8133 11.7062 15.5006 11.7062 15.1146V2.20984ZM12.6537 15.1146C12.6537 16.0242 11.9161 16.7619 11.0064 16.7619H2.20789C1.29826 16.7618 0.560547 16.0242 0.560547 15.1146V4.55596L0.570033 4.46321C0.588261 4.37214 0.633022 4.28745 0.69967 4.2208L4.21885 0.701623L4.29157 0.642601C4.36879 0.591141 4.45985 0.562554 4.55401 0.5625H11.0064C11.916 0.5625 12.6536 1.30021 12.6537 2.20984V15.1146Z"
									fill="#212121" />
								<path
									d="M2.90684 17.4608V16.2877C2.90684 16.0259 3.11931 15.8135 3.38112 15.8135C3.61012 15.8135 3.80162 15.9759 3.84592 16.1918L3.85541 16.2877V17.4608C3.85541 17.6463 3.92879 17.8242 4.05988 17.9551L4.16633 18.0426C4.28021 18.1187 4.41499 18.1596 4.55418 18.1596H13.3527C13.7387 18.1596 14.0525 17.8469 14.0525 17.4608V4.5561C14.0524 4.17009 13.7387 3.85732 13.3527 3.85732H12.1796C11.9178 3.85725 11.7053 3.64481 11.7053 3.38304C11.7053 3.12127 11.9178 2.90882 12.1796 2.90875H13.3527C14.2623 2.90875 14.9999 3.64647 15 4.5561V17.4608C15 18.3705 14.2624 19.1081 13.3527 19.1081H4.55418C4.17214 19.1081 3.80386 18.9753 3.51076 18.735L3.38956 18.6254C3.08032 18.3164 2.90684 17.8975 2.90684 17.4608Z"
									fill="#212121" />
								<path
									d="M4.66678 3.96991V1.03673H5.61535V3.96991C5.61519 4.87936 4.87745 5.61709 3.96801 5.61725H1.03483V4.66868H3.96801C4.35383 4.66853 4.66663 4.35574 4.66678 3.96991Z"
									fill="#212121" />
								<path
									d="M9.24692 7.60132L9.34283 7.6108C9.55865 7.65516 9.7212 7.84666 9.7212 8.0756C9.7212 8.30454 9.55865 8.49604 9.34283 8.5404L9.24692 8.54988H3.96763C3.70582 8.54988 3.49334 8.33741 3.49334 8.0756C3.49334 7.81379 3.70582 7.60132 3.96763 7.60132H9.24692Z"
									fill="#212121" />
								<path
									d="M9.24692 9.94766L9.34283 9.95714C9.55865 10.0015 9.7212 10.193 9.7212 10.4219C9.7212 10.6509 9.55865 10.8424 9.34283 10.8867L9.24692 10.8962H3.96763C3.70582 10.8962 3.49334 10.6837 3.49334 10.4219C3.49334 10.1601 3.70582 9.94766 3.96763 9.94766H9.24692Z"
									fill="#212121" />
								<path
									d="M6.9008 12.294L6.99566 12.3035C7.2119 12.3475 7.37508 12.539 7.37508 12.7683C7.37508 12.9975 7.2119 13.189 6.99566 13.2331L6.9008 13.2426H3.96763C3.70582 13.2426 3.49334 13.0301 3.49334 12.7683C3.49334 12.5065 3.70582 12.294 3.96763 12.294H6.9008Z"
									fill="#212121" />
							</svg>


						</button>
						<button class="me-1 my-0 sync-buttons"
							type="button"
							pmdRipple
							pmdBtn
							pmd-btn-outline
							color="dark"
							[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/user-management')}"
							size="xs"
							pmdTooltip="Regenerate sync code"
							container="body"
							placement="bottom"
							(click)="refreshSyncCode($event)">
							<svg width="17"
								height="15"
								viewBox="0 0 17 15"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M14.5498 6.09082C14.7031 6.09086 14.8395 6.14195 14.9502 6.24414L15.0098 6.29492L16.2705 7.53906C16.2716 7.54023 16.2791 7.5479 16.2793 7.55566H16.2959C16.3384 7.61512 16.3807 7.67492 16.4062 7.73438C16.4403 7.81104 16.458 7.88845 16.458 7.97363L16.4463 8.09277C16.4388 8.13319 16.4278 8.17363 16.415 8.21191L16.3564 8.32031C16.3342 8.35426 16.309 8.38629 16.2793 8.41602C16.2197 8.46713 16.1509 8.51839 16.0742 8.54395C15.9294 8.61202 15.7502 8.61207 15.6055 8.54395C15.5375 8.51841 15.4865 8.4839 15.4355 8.44141L15.4189 8.4248C15.4189 8.4248 15.4098 8.41667 15.4014 8.4082L15.1631 8.16895C15.0641 11.7834 12.159 14.7186 8.53125 14.9219L8.17773 14.9326L8.17676 14.8906H8.17773V14.9326H8.09277L7.64648 14.9189C6.75796 14.8618 5.89112 14.634 5.08887 14.251L4.69336 14.0469C3.65426 13.4676 2.77679 12.633 2.14648 11.6279L2.12109 11.6533V11.585C2.03602 11.4487 2.01022 11.287 2.05273 11.1338C2.0868 10.972 2.18895 10.8352 2.3252 10.75C2.46138 10.6649 2.63192 10.6399 2.78516 10.6738C2.92997 10.7079 3.05837 10.7929 3.14355 10.9121L3.16895 10.9463C3.68857 11.7896 4.42968 12.4966 5.29004 12.9736C6.04287 13.391 6.88046 13.6389 7.73438 13.6943L8.10156 13.7061H8.16113C11.2787 13.6888 13.8258 11.2358 13.9365 8.17773L13.6719 8.44141H13.6641C13.5618 8.53511 13.4163 8.58691 13.2715 8.58691H13.2637C13.102 8.58691 12.9483 8.51877 12.8291 8.4082C12.7184 8.28902 12.6505 8.13537 12.6504 7.97363C12.6504 7.93092 12.6545 7.89009 12.6631 7.85059L12.7012 7.73438C12.7139 7.70466 12.7291 7.67513 12.7461 7.64648L12.8037 7.56445L12.8379 7.53906L14.124 6.26953L14.1494 6.24414C14.2601 6.14194 14.405 6.09082 14.5498 6.09082ZM8.76562 0.0146484C9.79639 0.0827789 10.8036 0.386391 11.7129 0.885742C12.7436 1.465 13.6213 2.30048 14.2432 3.30566C14.26 3.3227 14.2682 3.34831 14.2852 3.36523C14.3192 3.42477 14.345 3.49252 14.3535 3.56055C14.3705 3.64569 14.3705 3.72248 14.3535 3.80762C14.3365 3.88421 14.303 3.9612 14.252 4.0293L14.168 4.12012C14.1383 4.14658 14.1062 4.17021 14.0723 4.19141L13.9639 4.24609C13.9256 4.26099 13.8853 4.2721 13.8428 4.27637C13.8045 4.28486 13.764 4.28726 13.7236 4.28516L13.6045 4.26758C13.5194 4.24205 13.4509 4.20824 13.3828 4.15723C13.3147 4.11469 13.2633 4.04658 13.2207 3.97852V3.96094C12.7586 3.23049 12.146 2.61148 11.4238 2.14844L11.1084 1.95898C10.3629 1.54153 9.52593 1.29368 8.67773 1.23828L8.31445 1.22656H8.25488C5.14562 1.2436 2.61562 3.69744 2.50488 6.74707L2.73438 6.52539L2.75977 6.49121C2.87902 6.39751 3.0244 6.34668 3.17773 6.34668C3.25412 6.34673 3.3305 6.36325 3.39844 6.38867C3.4751 6.42275 3.54389 6.46576 3.60352 6.52539C3.71415 6.64462 3.78223 6.7982 3.78223 6.95996L3.77148 7.07129C3.75032 7.17951 3.69919 7.27729 3.62891 7.36035L3.56934 7.42773L2.2998 8.68848H2.29102V8.68066C2.18038 8.78261 2.03588 8.84174 1.88281 8.8418C1.738 8.8418 1.59316 8.7907 1.48242 8.68848L1.45703 8.66309L0.144531 7.36035C0.050895 7.24969 7.34875e-05 7.11316 0 6.95996C0 6.79827 0.068163 6.6449 0.178711 6.53418C0.289378 6.415 0.442759 6.35457 0.604492 6.35449H0.613281C0.758041 6.35449 0.894165 6.39758 1.00488 6.49121H1.01367L1.27734 6.75488C1.37972 3.02394 4.46375 0.0256093 8.2373 0H8.32227L8.76562 0.0146484Z"
									fill="#212121" />
							</svg>
						</button>
					</div>
				</div>
			</li>
			<li>
				<a class="dropdown-item d-flex align-items-center"
					routerLinkActive='active'
					(click)="logout()"
					pmdRipple
					aria-label="Press enter to logout from the tool"
					role="menuitem"
					tabindex="0">
					<svg width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M16.0498 17.1846V18.71C16.0498 19.6427 15.3341 20.3477 14.5127 20.3477H7.18652C6.36529 20.3474 5.65042 19.6425 5.65039 18.71V5.28613C5.65042 4.35356 6.36529 3.64866 7.18652 3.64844H14.5127C15.3341 3.64844 16.0498 4.35341 16.0498 5.28613V6.81152C16.0498 7.17051 16.3412 7.46191 16.7002 7.46191C17.0591 7.46181 17.3496 7.17044 17.3496 6.81152V5.28613C17.3496 3.6915 16.1069 2.34766 14.5127 2.34766H7.18652C5.59254 2.34788 4.34964 3.69163 4.34961 5.28613V18.71C4.34964 20.3045 5.59254 21.6482 7.18652 21.6484H14.5127C16.1069 21.6484 17.3496 20.3046 17.3496 18.71V17.1846C17.3496 16.8257 17.0591 16.5343 16.7002 16.5342C16.3412 16.5342 16.0498 16.8256 16.0498 17.1846Z"
							fill="#212121" />
						<path
							d="M18.4131 12.6914L18.5439 12.6777C18.8402 12.6172 19.0635 12.3552 19.0635 12.041C19.0635 11.7268 18.8402 11.4648 18.5439 11.4043L18.4131 11.3906H10.5C10.141 11.3906 9.84961 11.682 9.84961 12.041C9.84961 12.4 10.141 12.6914 10.5 12.6914H18.4131Z"
							fill="#212121" />
						<path
							d="M15.6178 15.1107C15.8158 15.3546 16.1543 15.4183 16.4225 15.2787L16.5318 15.2064L18.7896 13.3744L18.943 13.2357C19.2809 12.8986 19.4723 12.463 19.4723 12.0013C19.4722 11.5396 19.281 11.104 18.943 10.767L18.7896 10.6293L16.5318 8.79722L16.4225 8.72496C16.1542 8.58513 15.8158 8.64798 15.6178 8.89195C15.3917 9.17067 15.4348 9.57981 15.7135 9.80601L17.9703 11.638L18.068 11.7347C18.1472 11.8313 18.1724 11.9259 18.1725 12.0013C18.1725 12.0767 18.1471 12.1714 18.068 12.2679L17.9703 12.3646L15.7135 14.1966L15.6197 14.2894C15.4279 14.523 15.4201 14.8668 15.6178 15.1107Z"
							fill="#212121" />
					</svg>

					Logout
				</a>
			</li>
		</ul>

	</div>
</pmd-navbar-right-icon>